import { Pill, Switch } from "@tag/tag-components-react-v4";
import React from "react";
import "./header.css";
import MockButton from "../accessButton/mockButton";
import { MoonLined, WeatherSunLined } from "@tag/tag-icons";
import { useTheme } from "../../context/themeContext";
import UserAvatar from "../userAvatar/userAvatar";
import { useUser } from "../../context/userProvider";

const Header: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const { currentUser, isLoaded } = useUser();
  return (
    <header className="header">
      <div className="header-left-section">
        <MockButton />
        <h3 className="header-app-name">{`Kitchen Wizard`}</h3>
      </div>
      <div className="header-right-section">
        {theme === "dark" ? (
          <MoonLined accent="teal" />
        ) : (
          <WeatherSunLined accent="teal" />
        )}
        <div className="header-theme-switch">
          <Switch accent="teal" onChange={() => toggleTheme()}>
            Theme
          </Switch>
        </div>

        {currentUser ? (
          <>
            <Pill accent="teal" variant="outlined">
              {currentUser.organisationName}
            </Pill>
            <UserAvatar user={currentUser} onUserChange={()=>{
              //Handle proper user changing once its decided how
              }} />
          </>
        ) : (
          //Care for user not setted up here, this is more of a blank screen
          <div>Loading user...</div>
        )}
      </div>
    </header>
  );
};

export default Header;
